import React from "react";
import "./Header.css";

const Header = () => {
  return <h1>Lista To-Do</h1>;
};

export default Header;
